import { Button, DialogActions, DialogContent, DialogTitle, Typography, IconButton, InputAdornment, TextField, Box, useMediaQuery } from '@mui/material';
import React from 'react';
import "./style.css";
import { useTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import ConfirmModal from './ConfirmModal';

const ModalContainer = ({ phoneNumber, BootstrapDialog, handleClose, handleContinue, open, content }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const data = useSelector(state => state.modal.data); // Get additional data from Redux
    const renderContent = () => {
        switch (content) {
            case 'confirmModal':
                return(
                    <>
                        <ConfirmModal handleClose={handleClose} confirmData={data}/>
                    </>
                );
            default:
                return (
                    <DialogContent sx={{ height: '200px', width: '400px' }}>
                        <Typography align="center">
                            No content available.
                        </Typography>
                    </DialogContent>
                );
        }
    };

    const dialogStyles = {
        borderRadius: '16px',
        width: '100%',
        maxWidth: '380px', // Conditional maxWidth
        minWidth: content == 'confirmModal'  ? '370px': 'fit-content',
        minHeight: content !== 'confirmModal' ? '500px': 'fit-content',
        height: 'auto',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.9)',
        padding: "20px",
    };

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            PaperProps={{
                sx: dialogStyles,
            }}
            fullWidth
            className='flex-property justify-content-center'
            content={content}
        >
            {renderContent()}
        </BootstrapDialog>
    );
};

export default ModalContainer;
